<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <h2>Confirmación de envío</h2>
            <div style="width: 100%; max-width: 400px; text-align:left;">
                <p v-if="configEnvio.entrada != 'contenido'"><b>Documentos</b></p>
                <template v-else>
                    <p><b>Contenido </b></p>
                    <p>{{ pub_titulo }}</p>
                </template>
                <div
                    :style="`width: 360px; height: ${0 + (33 * files.length)}px; max-height: 132px; overflow-y: auto; padding: 0px 10px 0px 10px; margin: 10px 0 10px 0; transition: 0.5s`">
                    <div v-for="archivo in files" :key="archivo.file.name"
                        :class="`documento ${archivo.tipo} ${archivo.tipo == 'error' ? 'apply-shake' : ''}`">
                        <font-awesome-icon v-if="archivo.icon != 'loading'" :icon="getIconPath(archivo.file.name)" />
                        <i v-else class="el-icon-loading"></i>
                        {{ archivo.file.name }}
                    </div>
                </div>
                <p><b>Receptores</b></p>
                <ul v-if="!configEnvio.autoemp"
                    style="width: 360px; max-height: 150px; overflow-y: auto; padding: 0px 10px 0px 10px;">
                    <li v-for="receptor in filteredEmpleados" :key="receptor.id + receptor.nombre" type="success"
                        class="documento">
                        <font-awesome-icon :icon="['fas', 'user']" />
                        {{ receptor.nombre }}
                    </li>
                </ul>
                <p v-else class="documento">Se obtienen automáticamente</p>
                <p><b>Proceso</b></p>
                <ul style="width: 360px; max-height: 150px; overflow-y: auto; padding: 0px 10px 0px 10px;">
                    <li class="documento" v-for="(opcion, index) in otrasOpciones" :key="`opcion${index}`"><i
                            :class="opcion.icono"></i>
                        {{ opcion.texto }}</li>
                </ul>
                <template v-if="working == 'documentos'">
                    <p><b>Notificación por email</b></p>
                    <el-switch style="margin-right: 10px;" v-model="configEnvio.notificar"></el-switch> {{ emailNotificacion
                        ?
                        'Activado' :
                        'Desactivado' }}
                </template>
            </div>
            <div style="display:flex; margin-top: 20px;">
                <el-button :type="working == 'documentos' ? 'primary' : 'warning'" icon="Back" @click="$router.go(-1)"
                    :disabled="leftDisabled" />
                <el-button v-if="configEnvio.accion == 'almacenar' && configEnvio.entrada == 'archivo'"
                    :type="working == 'documentos' ? 'primary' : 'warning'" icon="Check" :disabled="rightDisabled"
                    @click="enviarDocumento()" />
                <el-button
                    v-if="configEnvio.accion != 'firmar' && (configEnvio.accion == 'almacenar' && configEnvio.entrada != 'archivo')"
                    :type="working == 'documentos' ? 'primary' : 'warning'" icon="Check" :disabled="rightDisabled"
                    @click="enviarPublicacion()" />
                <el-button v-if="configEnvio.accion == 'firmar'" :type="working == 'documentos' ? 'primary' : 'warning'"
                    icon="Check" @click="enviarFirmar()">Enviar a firmar
                </el-button>
            </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
import * as dayjs from 'dayjs'
export default {
    name: 'ConfirmarEnvio',
    watch: {
    },
    components: {
    },
    data() {
        return {
            loading: false,
            paso: 1,
            tipoDocumento: '',
            acciones: {},
            emailNotificacion: false,
            working: process.env.VUE_APP_WORKING,
        }
    },
    mounted() {
        this.setPaginaActual('confirm')
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'paginaActual', 'documentos', 'content', 'pub_titulo'
        ]),
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            if (this.files.length == 0 && (!this.content || this.content == '')) {
                return true;
            }
            return false;
        },
        filteredEmpleados() {
            return this.receptores.filter(receptor =>
                receptor.tipo == 'empleado' && (receptor.selected || receptor.disabled)
            );
        },
        otrasOpciones() {
            let respuesta = [];
            if (this.configEnvio.accion == 'firmar') {
                respuesta.push({ icono: 'fa-solid fa-signature', texto: 'Documento a firmar' })
                respuesta.push({ icono: 'fa-solid fa-eye', texto: 'Seguimiento de firma' })
            }
            if (this.configEnvio.accion == 'almacenar') {
                respuesta.push({ icono: 'fa-solid fa-floppy-disk', texto: 'Documento a almacenar' })
            }
            if (this.working == 'documentos') {
                if (this.configEnvio.carpetaDestino) {
                    respuesta.push({ icono: 'fa-solid fa-folder-closed', texto: `Destino: ${this.configEnvio.carpetaDestino}` })
                }
                if (this.configEnvio.fechaExp) {
                    respuesta.push({ icono: 'fa-regular fa-calendar-check', texto: `Expira: ${dayjs(this.configEnvio.fechaExp).format('DD/MM/YYYY HH:mm:ss')}` })
                } else {
                    respuesta.push({ icono: 'fa-regular fa-calendar-xmark', texto: `Sin fecha de expiración` })
                }
                respuesta.push({ icono: 'fa-solid fa-eye', texto: 'Seguimiento de lectura' })
                if (this.configEnvio.consentimiento) {
                    respuesta.push({ icono: 'fa-solid fa-user-check', texto: 'Firmar consentimiento para leer' })
                } else {
                    respuesta.push({ icono: 'fa-solid fa-user-times', texto: 'No requiere consentimiento' })
                }
            }
            return respuesta;
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setPaginaActual',
            'setDocumentos',
            'setFiles'
        ]),
        async enviarDocumento() {
            const formData = new FormData();
            this.files.forEach((file, index) => {
                file.tipo = "secondary";
                file.icon = "loading";
                formData.append('file' + index, file.file);
            })
            formData.append('receptores', JSON.stringify(this.receptores));
            formData.append('carpetaDestino', this.configEnvio.carpetaDestino);
            formData.append('autoemp', this.configEnvio.autoemp);
            return fetch(process.env.VUE_APP_PORTAL + '/api/documentos/almacenarDocumentos', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(async response => {
                    console.log(response);
                    if (response.status == 200) {
                        this.$notify({
                            title: '¡Bien!',
                            message: 'Tu envío se ha realizado correctamente',
                            type: 'success'
                        });
                        this.$router.push('/dashboard')
                        this.loading = false;
                    } else if (response.status == 404) {
                        this.$notify({
                            title: '¡Oops!',
                            message: 'No se han encontrado usuarios a los que enviar el documento',
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: '¡Oops!',
                            message: 'Se ha producido un error',
                            type: 'error'
                        });
                    }
                })
                .catch(error => {
                    this.$notify({
                        title: '¡Oops!',
                        message: 'Se ha producido un error',
                        type: 'success'
                    });
                    this.loading = false;
                    throw error;
                });
        },
        async enviarPublicacion() {
            const formData = new FormData();
            this.files.forEach((file, index) => {
                file.tipo = "secondary";
                file.icon = "loading";
                formData.append('file' + index, file.file);
            })
            formData.append('receptores', JSON.stringify(this.receptores));
            formData.append('title', this.pub_titulo);
            formData.append('config', JSON.stringify(this.configEnvio));
            formData.append('contenido', this.content);
            return fetch(process.env.VUE_APP_PORTAL + '/api/publicaciones/publicacion', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(async response => {
                    console.log(response);
                    if (response.status == 200) {
                        // if (this.emailNotificacion) {
                        //     let receptoresemail = this.filteredEmpleados
                        //         .filter((empleado) => empleado.estado == null)
                        //         .map((m) => "'" + m.email + "'")
                        //         .join(',');

                        //     const apiUrl = process.env.VUE_APP_PORTAL + ':1881/postcreatedocumentos';

                        //     try {
                        //         const response = await fetch(apiUrl, {
                        //             method: 'POST',
                        //             headers: {
                        //                 'Content-Type': 'application/json',
                        //             },
                        //             body: JSON.stringify({ receptores: receptoresemail }), // Asegúrate de tener la variable 'cats' definida
                        //         });

                        //         const data = await response.json();
                        //         console.log('Respuesta:', data);
                        //     } catch (error) {
                        //         console.error('Error:', error);
                        //     }
                        //     this.emailNotificacion = false;
                        // }
                        this.$notify({
                            title: '¡Bien!',
                            message: 'Tu envío se ha realizado correctamente',
                            type: 'success'
                        });
                        this.$router.push('/dashboard')
                        this.loading = false;
                    } else {
                        this.$notify({
                            title: '¡Oops!',
                            message: 'Se ha producido un error',
                            type: 'success'
                        });
                    }
                })
                .catch(error => {
                    this.$notify({
                        title: '¡Oops!',
                        message: 'Se ha producido un error',
                        type: 'success'
                    });
                    this.loading = false;
                    throw error;
                });
        },
        isNIForNIE(value) {
            const nifRegex = /^[0-9]{8}[A-Z]$/i;
            const nieRegex = /^[XYZ][0-9]{7}[A-Z]$/i;

            if (nifRegex.test(value)) {
                return "NIF";
            } else if (nieRegex.test(value)) {
                return "NIE";
            } else {
                return "Other";
            }
        },
        async enviarFirmar() {
            this.loading = true;
            let response = '';
            for (let i = 0; i < this.documentos.length; i++) {
                let data = {}
                data.FileName = this.files[i].file.name;
                data.DocContent = this.documentos[i].pdfData;
                data.Signers = [];
                this.documentos[i].firmantes.forEach((firmante, index) => {
                    let signer = {};
                    signer.SignerID = index;
                    signer.SignerName = firmante.nombre;
                    signer.TypeOfID = this.isNIForNIE(firmante.dni);
                    signer.NumberID = firmante.dni;
                    signer.DeviceName = null;
                    signer.Visible = {
                        Page: firmante.eventClickImg.page.page,
                        PosX: Math.round(firmante.eventClickImg.px),
                        PosY: Math.round(firmante.eventClickImg.py),
                        SizeX: 40,
                        SizeY: 25
                    };
                    signer.PictureURI = null;
                    signer.eMail = firmante.email;
                    signer.SkipSignatureEmail = null;
                    signer.SignatureType = 'emailandsms';
                    signer.Language = this.documentos[i].data.idioma;
                    signer.AllowEmptyPhoneNumber = null;
                    signer.PhoneNumber = firmante.telefono.startsWith('+') ? firmante.telefono : `+34${firmante.telefono}`;
                    signer.eMailBody = this.documentos[i].data.cuerpo;
                    signer.eMailSubject = this.documentos[i].data.asunto;
                    signer.IssuerName = null;
                    signer.NotificationEmailMessage = {
                        eMailBody: this.documentos[i].data.cuerpo,
                        eMailSubject: this.documentos[i].data.asunto
                    };
                    signer.SendCentralizedSignerEmailNotification = null;
                    signer.Form = null;
                    signer.SendSignedDoc = true;
                    signer.FormInfo = null;
                    data.Signers.push(signer);
                    data.NotificationURL = process.env.VUE_APP_APIDOMAIN + "firmas/signatureservices/notificationApp";
                })
                data.OrderedSignatures = true;
                data.enviado_por = this.datosemp.mail;
                data.IssuerName = this.documentos[i].data.nombreEmisor;

                try {
                    response = await fetch(
                        `${process.env.VUE_APP_APIDOMAIN}firmas/enviarAFirmar`,
                        {
                            method: "POST",
                            body: JSON.stringify(data),
                        }
                    );

                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const result = await response.json();

                    if (response.ok) {
                        this.$notify({
                            title: '¡Bien!',
                            message: 'Se ha enviado a firmar correctamente.',
                            type: 'success'
                        });
                        this.listReset();
                    } else {
                        this.$notify({
                            title: 'Ha ocurrido un error',
                            message: 'No se ha completado correctamente el envío: ' + JSON.stringify(result),
                            type: 'error'
                        });
                    }
                } catch (error) {
                    this.$notify({
                        title: 'Error de red',
                        message: 'No se pudo completar la solicitud: ' + error.message,
                        type: 'error'
                    });
                    console.error('Error:', error);
                }
            }

            this.loading = false;
        },
        getIconPath(nombreArchivo) {
            let img = '';
            let ext = nombreArchivo.split('.').pop();
            switch (ext) {
                case 'ico':
                case 'gif':
                case 'jpg':
                case 'jpeg':
                case 'jpc':
                case 'jp2':
                case 'jpx':
                case 'xbm':
                case 'wbmp':
                case 'png':
                case 'bmp':
                case 'tif':
                case 'tiff':
                case 'webp':
                case 'avif':
                case 'svg':
                    img = 'fa-regular fa-image';
                    break;
                case 'passwd':
                case 'ftpquota':
                case 'sql':
                case 'js':
                case 'json':
                case 'sh':
                case 'config':
                case 'twig':
                case 'tpl':
                case 'md':
                case 'gitignore':
                case 'c':
                case 'cpp':
                case 'cs':
                case 'py':
                case 'rs':
                case 'map':
                case 'lock':
                case 'dtd':
                    img = 'fa-regular fa-file-code';
                    break;
                case 'txt':
                case 'ini':
                case 'conf':
                case 'log':
                case 'htaccess':
                case 'yaml':
                case 'yml':
                case 'toml':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'css':
                case 'less':
                case 'sass':
                case 'scss':
                    img = 'fa-brands fa-css3-alt';
                    break;
                case 'bz2':
                case 'zip':
                case 'rar':
                case 'gz':
                case 'tar':
                case '7z':
                case 'xz':
                    img = 'fa-regular fa-file-zipper';
                    break;
                case 'php':
                case 'php4':
                case 'php5':
                case 'phps':
                case 'phtml':
                    img = 'fa-solid fa-code';
                    break;
                case 'htm':
                case 'html':
                case 'shtml':
                case 'xhtml':
                    img = 'fa-brands fa-html5';
                    break;
                case 'xml':
                case 'xsl':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'wav':
                case 'mp3':
                case 'mp2':
                case 'm4a':
                case 'aac':
                case 'ogg':
                case 'oga':
                case 'wma':
                case 'mka':
                case 'flac':
                case 'ac3':
                case 'tds':
                    img = 'fa-solid fa-music';
                    break;
                case 'm3u':
                case 'm3u8':
                case 'pls':
                case 'cue':
                case 'xspf':
                    img = 'fa-solid fa-headphones';
                    break;
                case 'avi':
                case 'mpg':
                case 'mpeg':
                case 'mp4':
                case 'm4v':
                case 'flv':
                case 'f4v':
                case 'ogm':
                case 'ogv':
                case 'mov':
                case 'mkv':
                case '3gp':
                case 'asf':
                case 'wmv':
                case 'webm':
                    img = 'fa-regular fa-file-video';
                    break;
                case 'eml':
                case 'msg':
                    img = 'fa-regular fa-envelope';
                    break;
                case 'xls':
                case 'xlsx':
                case 'ods':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'csv':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'bak':
                case 'swp':
                    img = 'fa-regular fa-clipboard';
                    break;
                case 'doc':
                case 'docx':
                case 'odt':
                    img = 'fa-regular fa-file-word';
                    break;
                case 'ppt':
                case 'pptx':
                    img = 'fa-regular fa-file-powerpoint';
                    break;
                case 'ttf':
                case 'ttc':
                case 'otf':
                case 'woff':
                case 'woff2':
                case 'eot':
                case 'fon':
                    img = 'fa-solid fa-font';
                    break;
                case 'pdf':
                    img = 'fa-regular fa-file-pdf';
                    break;
                case 'psd':
                case 'ai':
                case 'eps':
                case 'fla':
                case 'swf':
                    img = 'fa-regular fa-file-image';
                    break;
                case 'exe':
                case 'msi':
                    img = 'fa-regular fa-file';
                    break;
                case 'bat':
                    img = 'fa-solid fa-terminal';
                    break;
                default:
                    img = 'fa-solid fa-circle-info';
                    break;
            }
            return img;
        },
        listReset() {
            this.receptores.forEach(receptor => {
                receptor.selected = false;
                receptor.disabled = false;
            });
            this.actualizarReceptores();
            this.setFiles([]);
            this.setDocumentos([]);
            this.emailNotificacion = false;
            this.$router.push('/dashboard')
        },
        actualizarReceptores() {
            // Definir el orden de los tipos
            var ordenTipos = [
                "empresa",
                "área",
                "centro",
                "departamento",
                "empleado",
            ];
            // Ordenar el array
            // this.receptores.sort(function (a, b) {
            //   return a.localeCompare(b);
            // })
            if (this.working == 'documentos') {
                this.receptores.sort(function (a, b) {
                    if (a.selected && !b.selected) {
                        return -1; // a viene antes que b (a es selected y b no)
                    } else if (!a.selected && b.selected) {
                        return 1; // b viene antes que a (b es selected y a no)
                    } else if (a.disabled && !b.disabled) {
                        return 1; // b viene antes que a (a es disabled y b no)
                    } else if (!a.disabled && b.disabled) {
                        return -1; // a viene antes que b (b es disabled y a no)
                    } else {
                        // Si tienen el mismo valor para "selected" y "disabled", ordenar por "tipo" y luego por "id"
                        var tipoA = ordenTipos.indexOf(a.tipo);
                        var tipoB = ordenTipos.indexOf(b.tipo);
                        if (tipoA !== tipoB) {
                            return tipoA - tipoB; // Ordenar por "tipo" según el orden definido en "ordenTipos"
                        } else if (a.nombre != null && b.nombre != null) {
                            return a.nombre.localeCompare(b.nombre); // Ordenar por "id" en orden ascendente
                        }
                    }
                });
            }
            this.uploadData = {
                receptores: JSON.stringify(this.receptores),
            };
            this.numSeleccion = {
                empresas: 0,
                areas: 0,
                centros: 0,
                departamentos: 0,
                empleados: 0,
                total: 0,
            };
            let receptores = this.receptores.filter(function (receptor) {
                return receptor.selected;
            });
            receptores.forEach((receptor) => {
                switch (receptor.tipo) {
                    case "empresa":
                        this.numSeleccion.empresas++;
                        break;
                    case "área":
                        this.numSeleccion.areas++;
                        break;
                    case "centro":
                        this.numSeleccion.centros++;
                        break;
                    case "departamento":
                        this.numSeleccion.departamentos++;
                        break;
                    case "empleado":
                        this.numSeleccion.empleados++;
                        break;
                }
                this.documentos.forEach((doc) => {
                    doc.firmantes = [];
                });
            });
            this.numSeleccion.total =
                this.numSeleccion.empresas +
                this.numSeleccion.areas +
                this.numSeleccion.centros +
                this.numSeleccion.departamentos +
                this.numSeleccion.empleados;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.documento {
    padding: 0 10px;
    line-height: 30px;
    font-size: 1rem;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    height: auto;
    border: none;
    background: none;
    color: dimgray;
    text-align: left;

    &.success {
        color: #67C23A;
    }

    &.error {
        color: #f56c6c;
    }
}

#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;
        padding: 0px;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
}
</style>